import React from 'react';

// Map language codes to country codes for flags
const languageToCountry: Record<string, string> = {
    fr: 'fr',
    en: 'gb',
    es: 'es',
    de: 'de',
    it: 'it',
    zh: 'cn',
};

interface FlagProps {
    langCode: string;
    size?: number;
    className?: string;
}

/**
 * Flag component using local assets for offline support.
 * Flags are stored in /public/flags/ as .webp files.
 */
export const Flag: React.FC<FlagProps> = ({ langCode, size = 20, className = "" }) => {
    const countryCode = languageToCountry[langCode] || langCode;
    const flagPath = `/flags/${countryCode}.webp`;

    return (
        <img
            src={flagPath}
            width={size}
            height={Math.round(size * 0.75)}
            alt={`${langCode} flag`}
            className={`rounded-sm object-cover ${className}`}
            style={{ minWidth: size }}
            onError={(e) => {
                // Fallback si l'image locale est manquante (affichage du code pays)
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                const parent = target.parentElement;
                if (parent && !parent.querySelector('.flag-fallback')) {
                    const span = document.createElement('span');
                    span.className = 'flag-fallback text-[10px] font-bold text-zinc-500 uppercase';
                    span.innerText = langCode;
                    parent.appendChild(span);
                }
            }}
        />
    );
};
